import Head from "next/head";
import Layout from "../components/Layout";
import BannerAd from "../components/BannerAd";

import { getArticles } from "../utils/api";
import { maxSection1, mediumFont } from "../utils/styles";
import OverlayImage from "../components/OverlayImage";

const Articles = ({ articles }) => {
  return (
    <Layout>
      <Head>
        <title>
          New Articles about Video Games, the Gaming Industry, Esports, In-depth Analysis - AppCheeta
        </title>
      </Head>
      <div className="page-content">
        <style jsx>
          {`
            .categories {
              display: grid;
              grid-template-columns: 1fr;
            }
            .subtitle {
              font-size: ${mediumFont};
              font-weight: bold;
              margin-top: 1.5rem;
              margin-bottom: 1.2rem;
              padding-left: 1.2rem;
            }
            @media screen and (min-width: ${maxSection1}px) {
              .categories {
                grid-template-columns: 1fr 1fr;
              }
            }
          `}
        </style>
        <BannerAd />
        <h2 className="subtitle">Articles</h2>
        <div className="section categories">
          {articles.map((article) => (
            <a className="category" key={article.slug} href={`/article/${article.slug}`}>
              <OverlayImage
                path={article.image}
                width={maxSection1}
                height={maxSection1 * 0.4848}
                overlay={article.title}
              />
            </a>
          ))}
        </div>
      </div>
    </Layout>
  );
};

Articles.getInitialProps = async ({ cached }) => {
  const { articles } = await getArticles({ cached });
  return { articles };
};

export default Articles;
